import { render } from "./CardDemand.vue?vue&type=template&id=2347a5ca&scoped=true&ts=true"
import script from "./CardDemand.vue?vue&type=script&lang=ts"
export * from "./CardDemand.vue?vue&type=script&lang=ts"

import "./CardDemand.vue?vue&type=style&index=0&id=2347a5ca&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2347a5ca"]])

export default __exports__